import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelectedAccount } from '@ibk/shared-auth';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { useGetHomePermissions } from '@ibk/shared-permissioning';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { sharedUiTranslations } from '../../translations';
import ProfileMenuItem from '../ProfileMenuItem';
export const ProfileMenuIncomeReportItemBase = () => {
    const { t } = useTranslation();
    const { hasAccountPjPermission } = useGetHomePermissions();
    const { selectedAccount } = useSelectedAccount();
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const navigate = useNavigate();
    if (!selectedAccount?.accountId) {
        return null;
    }
    if (!hasAccountPjPermission) {
        return null;
    }
    if (!isFeatureFlagWhiteListed(FeatureFlagUseCase.CONTA_INFORME_DE_RENDIMENTO)) {
        return null;
    }
    return (_jsx(ProfileMenuItem, { title: t('profile-menu-item.income-report'), onClick: () => navigate('/conta-pj/informe-de-rendimentos') }));
};
export const ProfileMenuIncomeReportItem = () => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(ProfileMenuIncomeReportItemBase, {}) }));
};
export default ProfileMenuIncomeReportItem;
